window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages.Safra = window.FazendaRP.Pages.Safra || {};

window.FazendaRP.Pages.Safra.Config = {
    openModal: async function () {
        // Fetch safras for dropdown
        const { data: safras, error: safrasError } = await window.FazendaRP.supabase
            .from('safras')
            .select('*')
            .order('ano', { ascending: false });

        if (safrasError || !safras || safras.length === 0) {
            alert('❌ Nenhuma safra cadastrada!\n\nCadastre uma safra primeiro no módulo Sistema.');
            return;
        }

        const modalId = 'modal-safra-config';
        let modal = document.getElementById(modalId);

        if (!modal) {
            modal = document.createElement('div');
            modal.id = modalId;
            modal.className = 'modal-overlay';
            modal.innerHTML = `
                <div class="modal-content" style="max-width: 550px;">
                    <div class="modal-header">
                        <h3>🌱 Nova Variedade</h3>
                        <button class="close-modal" onclick="document.getElementById('${modalId}').remove()">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="form-nova-variedade">
                            <!-- Safra Selection -->
                            <div class="form-group" style="margin-bottom: 20px;">
                                <label style="font-weight: 500; margin-bottom: 8px; display: block;">Safra *</label>
                                <select id="safra-select" class="form-control" required style="width: 100%;">
                                    ${safras.map((s, i) => `
                                        <option value="${s.id}" ${i === 0 ? 'selected' : ''}>
                                            ${s.ano} - ${s.cultura} (${s.area_plantada} ha)
                                        </option>
                                    `).join('')}
                                </select>
                            </div>

                            <!-- Variedade Name -->
                            <div class="form-group" style="margin-bottom: 20px;">
                                <label style="font-weight: 500; margin-bottom: 8px; display: block;">Nome da Variedade *</label>
                                <input 
                                    list="variedades-comuns" 
                                    id="nome-variedade" 
                                    class="form-control" 
                                    placeholder="Ex: Soja TMG 7062" 
                                    required 
                                    style="width: 100%;"
                                >
                                <datalist id="variedades-comuns">
                                    <option>Soja TMG 7062</option>
                                    <option>Soja Brasmax Potência</option>
                                    <option>Soja Intacta RR2</option>
                                    <option>Soja Monsoy 8644</option>
                                    <option>Milho Pioneer 30F53</option>
                                    <option>Milho Dekalb DKB</option>
                                    <option>Sorgo BRS 330</option>
                                    <option>Algodão FM 975</option>
                                </datalist>
                            </div>

                            <!-- Area Input -->
                            <div class="form-group" style="margin-bottom: 20px;">
                                <label style="font-weight: 500; margin-bottom: 8px; display: block;">Área (hectares) *</label>
                                <div style="position: relative;">
                                    <input 
                                        type="number" 
                                        id="area-variedade" 
                                        class="form-control" 
                                        placeholder="0.00" 
                                        step="0.01" 
                                        min="0.01"
                                        required 
                                        style="width: 100%; padding-right: 40px;"
                                    >
                                    <span style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); color: #94a3b8; font-size: 0.9rem;">ha</span>
                                </div>
                            </div>

                            <!-- Visual Feedback -->
                            <div id="area-feedback" style="margin-bottom: 20px; padding: 15px; background: #f8fafc; border-radius: 6px; border: 1px solid #e2e8f0;">
                                <div style="display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 0.9rem; color: #64748b;">
                                    <span>Área disponível:</span>
                                    <span id="area-disponivel-text" style="font-weight: 600; color: #059669;">— ha</span>
                                </div>
                                <div style="width: 100%; height: 12px; background: #e2e8f0; border-radius: 6px; overflow: hidden;">
                                    <div id="barra-progresso" style="width: 0%; height: 100%; background: #10b981; transition: all 0.3s;"></div>
                                </div>
                                <div id="percentual-text" style="text-align: right; margin-top: 5px; font-size: 0.85rem; color: #64748b;">0% utilizado</div>
                            </div>

                            <!-- Submit Button -->
                            <div style="text-align: right;">
                                <button type="submit" class="btn btn-primary" style="width: 100%;">
                                    <i class="fas fa-save"></i> Salvar Variedade
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            `;
            document.body.appendChild(modal);
        }

        // Store safras data
        this.safrasData = safras;

        // Setup event listeners
        this.setupModalEvents();

        // Initial feedback update
        await this.updateAreaFeedback();
    },

    loadAreas: async function () {
        const list = document.getElementById('areas-list');
        list.innerHTML = '<div style="text-align:center"><i class="fas fa-spinner fa-spin"></i> Carregando...</div>';

        const { data: areas, error } = await window.FazendaRP.supabase
            .from('safras_areas')
            .select('*')
            .order('variedade');

        list.innerHTML = '';

        if (areas && areas.length > 0) {
            areas.forEach(a => this.addAreaRow(a.variedade, a.area_ha, a.id));
        } else {
            // Default Empty Row
            this.addAreaRow('', 0, null);
        }
    },

    setupModalEvents: function () {
        const safraSelect = document.getElementById('safra-select');
        const areaInput = document.getElementById('area-variedade');
        const form = document.getElementById('form-nova-variedade');

        // Update feedback when safra changes
        safraSelect.addEventListener('change', () => this.updateAreaFeedback());

        // Update feedback when area changes
        areaInput.addEventListener('input', () => this.updateAreaFeedback());

        // Form submit
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.saveNewVariedade();
        });
    },

    updateAreaFeedback: async function () {
        const safraId = document.getElementById('safra-select')?.value;
        const novaArea = parseFloat(document.getElementById('area-variedade')?.value || 0);

        if (!safraId) return;

        // Get safra total area
        const safra = this.safrasData.find(s => s.id == safraId);
        if (!safra) return;

        // Get existing varieties for this safra
        const { data: variedades } = await window.FazendaRP.supabase
            .from('safras_areas')
            .select('area_ha')
            .eq('safra_id', safraId);

        const areaUsada = (variedades || []).reduce((sum, v) => sum + (v.area_ha || 0), 0);
        const areaDisponivel = safra.area_plantada - areaUsada;
        const areaAposNova = areaUsada + novaArea;
        const percentual = Math.min((areaAposNova / safra.area_plantada) * 100, 100);

        // Update text
        const textEl = document.getElementById('area-disponivel-text');
        if (textEl) {
            textEl.innerText = `${areaDisponivel.toFixed(2)} ha de ${safra.area_plantada} ha`;
            textEl.style.color = areaDisponivel < novaArea ? '#dc2626' : '#059669';
        }

        // Update progress bar
        const barraEl = document.getElementById('barra-progresso');
        if (barraEl) {
            barraEl.style.width = `${percentual}%`;
            barraEl.style.background = percentual > 100 ? '#dc2626' : percentual > 90 ? '#f59e0b' : percentual > 70 ? '#eab308' : '#10b981';
        }

        // Update percentage text
        const pctEl = document.getElementById('percentual-text');
        if (pctEl) {
            pctEl.innerText = `${percentual.toFixed(1)}% utilizado`;
            pctEl.style.color = percentual > 100 ? '#dc2626' : '#64748b';
        }
    },

    saveNewVariedade: async function () {
        const safraId = parseInt(document.getElementById('safra-select').value);
        const variedade = document.getElementById('nome-variedade').value.trim();
        const area = parseFloat(document.getElementById('area-variedade').value);

        if (!safraId || !variedade || !area || area <= 0) {
            alert('❌ Preencha todos os campos corretamente!');
            return;
        }

        // Validate area
        const safra = this.safrasData.find(s => s.id == safraId);
        const { data: variedades } = await window.FazendaRP.supabase
            .from('safras_areas')
            .select('area_ha')
            .eq('safra_id', safraId);

        const areaUsada = (variedades || []).reduce((sum, v) => sum + (v.area_ha || 0), 0);
        const areaDisponivel = safra.area_plantada - areaUsada;

        if (area > areaDisponivel) {
            alert(`❌ Área insuficiente!\n\nDisponível: ${areaDisponivel.toFixed(2)} ha\nVocê tentou cadastrar: ${area.toFixed(2)} ha`);
            return;
        }

        // Save to database
        const payload = {
            safra_id: safraId,
            variedade: variedade,
            area_ha: area
        };

        const { error } = await window.FazendaRP.supabase
            .from('safras_areas')
            .insert([payload]);

        if (error) {
            alert('❌ Erro ao salvar: ' + error.message);
            console.error(error);
        } else {
            alert('✅ Variedade cadastrada com sucesso!');
            document.getElementById('modal-safra-config').remove();
            // Reload Dashboard if active
            if (window.FazendaRP.Pages.Safra.Dashboard) {
                window.FazendaRP.Pages.Safra.Dashboard.init();
            }
        }
    }
};
